import { render, staticRenderFns } from "./qa-page.vue?vue&type=template&id=39382362&scoped=true"
import script from "./qa-page.vue?vue&type=script&lang=js"
export * from "./qa-page.vue?vue&type=script&lang=js"
import style0 from "./qa-page.vue?vue&type=style&index=0&id=39382362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39382362",
  null
  
)

export default component.exports